import React, { createElement } from 'react';
import { motion } from 'framer-motion';
interface SlideLayoutProps {
  children: React.ReactNode;
  centered?: boolean;
  className?: string;
}
export function SlideLayout(props: SlideLayoutProps) {
  var centered = props.centered || false;
  var extra = props.className || '';
  var padClasses = centered ? 'flex flex-col items-center justify-center px-5 sm:px-8 md:px-10 pt-6 sm:pt-8' : 'pt-10 sm:pt-14 md:pt-16 px-5 sm:px-8 md:px-12 lg:px-24';
  return createElement(motion.div, {
    initial: {
      opacity: 0,
      y: 20
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: -20
    },
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    },
    className: 'absolute inset-0 w-full h-full bg-gradient-to-br from-white to-slate-50 overflow-y-auto pb-24 sm:pb-28 ' + padClasses + ' ' + extra
  }, createElement('div', {
    className: 'max-w-6xl mx-auto w-full' + (centered ? ' text-center' : '')
  }, props.children));
}